import React, { useContext, useEffect } from "react";
import Loader from "../../SharedComponents/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { Col, Modal, Row } from "antd";
import classes from "../Modal.module.css";
import CommonButton from "../../Components/Buttons/CommonButton";
import { useFormik } from "formik";
import { lengths } from "../../Shared/Constants";
import { CatchMessage, JSONtoformdata, TrimStart } from "../../Shared/Methods";
import Commonselectfield from "../../Components/CommonForms/CommonSelectField";
import * as Yup from "yup";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import {
  CreateDeviceMeter,
  UpdateDeviceMeter,
} from "../../Services/ApiServices";
import { toast } from "react-toastify";
import CommonInputTwo from "../../Components/CommonForms/CommonInputTwo";
import { devicecontext } from "../../Screens/HomeScreen/ViewDevice";

const validation = Yup.object().shape({
  // parameter_type_id: Yup.string().required("Parameter type is required"),
  meter_code: Yup.string().required("Slave ID is required"),
  make: Yup.string().required("Make is required"),
  model: Yup.string().required("Model is required"),
  meter_name: Yup.string().required("Meter Name is required"),
});

interface formikprops {
  meter_name: string;
  // parameter_type_id: null,
  meter_code: any;
  make: any;
  model: any;
  register_type: string | number;
  meter_id: string;
  organization_id: string;
  device_id: string;
  baudrate: null | number;
  databits: any;
  parity: any;
  stopbits: any;
}

function Createdevicemetermodal({
  closable,
  open,
  Action,
  onCancel,
  handleSuccess,
  items,
  DropDowns,
  Dropdowns,
}: {
  closable: boolean;
  open: boolean;
  onCancel: () => void;
  handleSuccess: (type: string) => void;
  Action: string;
  items: any;
  DropDowns: any;
  Dropdowns: any;
}) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const dispatch = useDispatch();
  const {
    ParameterType,
    MeterCode,
    Make,
    Model,
    Baudrate,
    Parity,
    Databits,
    Stopbits,
    isParameterTypeLoading,
    isMeterLoading,
    isMakeLoading,
    isModalLoading,
    isBaudrateLoading,
    isParityLoading,
    isDatabitsLoading,
    isStopbitsLoading,
  } = DropDowns || {};
  const {
    getParameterTypeDropDown,
    getMakeDropDown,
    getModelDropDown,
    getDataBitsDropDown,
    getParityDropDown,
    getBaudrateDropDown,
    getStopBitsDropDown,
  } = Dropdowns || {};
  const context = useContext(devicecontext);
  const { item } = context || {};

  const {
    values,
    handleSubmit,
    setFieldValue,
    errors,
    touched,
    handleChange,
    setValues,
  } = useFormik({
    initialValues: {
      meter_name: "",
      // parameter_type_id: null,
      meter_code: null,
      make: undefined,
      model: null,
      register_type: 3,
      meter_id: "",
      organization_id: "",
      device_id: "",
      baudrate: null,
      databits: null,
      stopbits: null,
      parity: null,
    },
    validationSchema: validation,
    onSubmit: (value: formikprops) => {
      if (Action === "Create") {
        HandleCreateMeter();
      } else {
        HandleUpdateMeter();
      }
    },
  });

  useEffect(() => {
    if (items) {
      setValues({
        ...values,
        meter_name: items?.meter_name || "",
        // parameter_type_id: items?.parameter_type_id || null,
        meter_code: items?.meter_code || null,
        make: items?.make || undefined,
        model: items?.model || null,
        register_type: 3,
        organization_id: items?.organization_id || "",
        meter_id: items?.meter_id || "",
        device_id: items?.device_id || "",
        baudrate: items?.baudrate || null,
        databits: items?.databits || null,
        stopbits: items?.stopbits || null,
        parity: items?.parity !== "" ? items?.parity : null,
      });
      getModelDropDown(items?.make);
    }

    getMakeDropDown();
    getDataBitsDropDown();
    getParityDropDown();
    getBaudrateDropDown();
    getStopBitsDropDown();
  }, [items]);

  const HandleCreateMeter = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
      device_id: item?.deviceId,
    };

    CreateDeviceMeter(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess("create");
          toast.success(res?.data?.msg);
          onCancel();
        }
        if (res?.data?.status == 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const HandleUpdateMeter = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      ...values,
    };

    UpdateDeviceMeter(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess("update");
          toast.success(res?.data?.msg);
          onCancel();
        } else {
          toast.success(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <Loader isLoader={loading} />
      <Modal open={open} closable={closable} width={900} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>{Action} Meter</h4>

          <Row gutter={[16, 16]}>
            <Col md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="meter_name"
                value={values.meter_name}
                onChange={(e) => {
                  setFieldValue("meter_name", TrimStart(e.target.value));
                }}
                error={errors}
                touched={touched}
                required={true}
                labelname="Meter Name"
                maxLength={lengths.Names}
              />
            </Col>

            <Col md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="meter_code"
                value={values.meter_code}
                onChange={(e) => {
                  setFieldValue("meter_code", TrimStart(e.target.value));
                }}
                error={errors}
                touched={touched}
                required={true}
                labelname="Slave ID"
                maxLength={lengths.meterCode}
                readonly={Action !== "Create" ? true : false}
              />
            </Col>
            <Col md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="register_type"
                value={values.register_type}
                onChange={(e) => {
                  setFieldValue("register_type", TrimStart(e.target.value));
                }}
                error={errors}
                touched={touched}
                labelname="Register Type"
                maxLength={lengths.Names}
                readonly={true}
              />
            </Col>

            <Col md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Make"
                value={values.make}
                onChange={(value) => {
                  setValues({ ...values, make: value, model: null });
                  getModelDropDown(value);
                }}
                style={{ width: "100%" }}
                options={Make.map((ele: any) => {
                  return {
                    label: ele?.brand_name,
                    value: ele?.brand_id,
                  };
                })}
                size="large"
                required={true}
                error={errors}
                touched={touched}
                name="make"
                disabled={isMakeLoading}
                loading={isMakeLoading}
              />
            </Col>

            <Col md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Model"
                value={values.model}
                onChange={(value) => {
                  setValues({ ...values, model: value });
                }}
                style={{ width: "100%" }}
                options={Model.map((ele: any) => {
                  return {
                    label: ele?.model_name,
                    value: ele?.model_id,
                  };
                })}
                size="large"
                required={true}
                error={errors}
                touched={touched}
                name="model"
                disabled={isModalLoading}
                loading={values.make && isModalLoading}
              />
            </Col>

            <Col md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Baudrate"
                value={values.baudrate}
                onChange={(value) => {
                  setValues({ ...values, baudrate: value });
                }}
                style={{ width: "100%" }}
                options={Baudrate?.map((ele: any) => {
                  return { label: ele?.baudrate, value: ele?.baudrate };
                })}
                size="large"
                error={errors}
                touched={touched}
                required={false}
                name="baudrate"
                disabled={isBaudrateLoading}
                loading={isBaudrateLoading}
              />
            </Col>

            <Col md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Data Bits"
                value={values.databits}
                onChange={(value) => {
                  setValues({ ...values, databits: value });
                }}
                style={{ width: "100%" }}
                options={Databits?.map((ele: any) => {
                  return { label: ele?.description, value: ele?.description };
                })}
                size="large"
                error={errors}
                touched={touched}
                required={false}
                name="databits"
                disabled={isDatabitsLoading}
                loading={isDatabitsLoading}
              />
            </Col>

            <Col md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Stop Bits"
                value={values.stopbits}
                onChange={(value) => {
                  setValues({ ...values, stopbits: value });
                }}
                style={{ width: "100%" }}
                options={Stopbits?.map((ele: any) => {
                  return { label: ele?.description, value: ele?.description };
                })}
                size="large"
                error={errors}
                touched={touched}
                required={false}
                name="stopbits"
                disabled={isStopbitsLoading}
                loading={isStopbitsLoading}
              />
            </Col>

            <Col md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Parity"
                value={values.parity}
                onChange={(value) => {
                  setValues({ ...values, parity: value });
                }}
                style={{ width: "100%" }}
                options={Parity?.map((ele: any) => {
                  return { label: ele?.description, value: ele?.id };
                })}
                size="large"
                error={errors}
                touched={touched}
                required={false}
                name="parity"
                disabled={isParityLoading}
                loading={isParityLoading}
              />
            </Col>

            {/* <Col md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="organization_id"
                value={values.organization_id}
                onChange={(e) => {
                  setFieldValue("organization_id", TrimStart(e.target.value));
                }}
                error={errors}
                touched={touched}
                labelname="Organization"
                maxLength={lengths.Names}
              />
            </Col> */}

            {/* <Col md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Parameter Type"
                value={values.parameter_type_id}
                onChange={(value) => {
                  setValues({ ...values, parameter_type_id: value });
                }}
                style={{ width: "100%" }}
                options={ParameterType.map((ele: any) => {
                  return {
                    label: `${ele?.model_name} - ${ele?.brand_name}`,
                    value: ele?.id,
                  };
                })}
                size="large"
                required={true}
                error={errors}
                touched={touched}
                name="parameter_type_id"
              />
            </Col> */}

            {/* <Col md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="model"
                value={values.model}
                onChange={(e) => {
                  setFieldValue("model", TrimStart(e.target.value));
                }}
                error={errors}
                touched={touched}
                labelname="Model"
                maxLength={lengths.model}
              />
            </Col> */}

            {/* <Col md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="make"
                value={values.make}
                onChange={(e) => {
                  if (AcceptNumbersandLetters(e.nativeEvent.data)) {
                    setFieldValue("make", TrimStart(e.target.value));
                  }
                }}
                error={errors}
                touched={touched}
                labelname="Make"
                maxLength={lengths.make}
              />
            </Col> */}
          </Row>
          <div className={classes.modal_button_container}>
            <CommonButton
              name="Submit"
              onClick={handleSubmit}
              type="submit"
              classname="submit_btn"
            />
            <CommonButton
              name="Cancel"
              type="button"
              onClick={() => onCancel()}
              // style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Createdevicemetermodal;
